"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSprite = void 0;
const pixi_js_1 = require("pixi.js");
const Utils_1 = require("../Utils/Utils");
class DigitSprite extends pixi_js_1.Sprite {
    constructor(num, texture) {
        super(texture);
        this.num = num;
        this.anchor.set(0.5);
    }
}
const charCodeZero = "0".charCodeAt(0);
class NumberContentSprite extends pixi_js_1.Container {
    constructor(numberTextures) {
        super();
        this.tex = [];
        this.spritepool = [];
        this.charWidth = 0;
        this.charHeight = 0;
        this.tint = 0xffffff;
        /** the size of max height of number textures */
        this.fontSize = 36;
        this.padding = 4;
        this.tex = numberTextures;
        this.charWidth = Math.max(...numberTextures.map(x => x.width));
        this.charHeight = Math.max(...numberTextures.map(x => x.height));
        for (let i = 0; i < 10; i++) {
            this.spritepool[i] = new Utils_1.ObjectPool(() => new DigitSprite(i, this.tex[i]));
        }
    }
    setValue(num) {
        const digits = num
            .toFixed()
            .split("")
            .map(x => x.charCodeAt(0) - charCodeZero);
        const scale = this.fontSize / this.charHeight;
        const dx = this.charWidth * scale + this.padding;
        const offx = (this.charWidth * scale) / 2;
        const offy = (this.charHeight * scale) / 2;
        for (const x of this.children) {
            this.spritepool[x.num].save(x);
        }
        this.removeChildren();
        for (let i = 0; i < digits.length; i++) {
            const x = digits[i];
            const s = this.spritepool[x].get();
            s.position.set(offx + dx * i, offy);
            s.scale.set(scale);
            s.tint = this.tint;
            this.addChild(s);
        }
    }
}
class NumberSprite extends pixi_js_1.Container {
    constructor(numberTextures) {
        super();
        this.content = new NumberContentSprite(numberTextures);
        this.addChild(this.content);
        this.anchor = new pixi_js_1.ObservablePoint(() => {
            this.justifyPos();
        }, undefined);
    }
    get tint() {
        return this.content.tint;
    }
    set tint(v) {
        this.content.tint = v;
    }
    get fontSize() {
        return this.content.fontSize;
    }
    set fontSize(v) {
        this.content.fontSize = v;
    }
    get padding() {
        return this.content.padding;
    }
    set padding(v) {
        this.content.padding = v;
    }
    setValue(num) {
        this.content.setValue(num);
        this.justifyPos();
    }
    justifyPos() {
        const scale = this.fontSize / this.content.charHeight;
        const width = this.content.children.length * this.content.charWidth * scale +
            (this.content.children.length - 1) * this.padding;
        const height = this.content.charHeight * scale;
        this.content.position.set(-width * this.anchor.x, -height * this.anchor.y);
    }
}
exports.NumberSprite = NumberSprite;
//# sourceMappingURL=NumberSprite.js.map